var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionalViewSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dimensional-view_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.9999 53.8856L54.452 44.6595V24.346L35.9999 15.2819L17.5479 24.346V44.6595L35.9999 53.8856Z",
    stroke: "#242424",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5479 25.4521H17.6288L35.9999 34.5432V54.4521",
    stroke: "#FD8819",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36 54.4521V34.5432L54.3712 25.4521H54.4521",
    stroke: "#242424",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.452 25.4521H54.3711L35.9999 34.5432L17.6288 25.4521H17.5479",
    stroke: "#242424",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7 20.1916V7H20.1916",
    stroke: "#FD8819",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.1916 65H7V51.8083",
    stroke: "#FD8819",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65 51.8083V65H51.8083",
    stroke: "#FD8819",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M51.8083 7H65V20.1916",
    stroke: "#FD8819",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionalViewSvgrepocom);
export default __webpack_public_path__ + "static/media/dimensional-view_svgrepo.com.7c141e324954ede101e0087d1ac0cc4a.svg";
export { ForwardRef as ReactComponent };